var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "radio-selectors" }, [
    _vm.config.label
      ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.config.label))])])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "selectors" }, [
      _c(
        "div",
        { class: _vm.styleClass },
        _vm._l(_vm.optionKeys, function (key) {
          return _c(
            "label",
            {
              key: key,
              staticClass: "option mb-md-0",
              on: {
                change: function ($event) {
                  return _vm.updateModel(key)
                },
              },
            },
            [
              _c("input", {
                staticClass: "selector",
                attrs: { type: _vm.style },
                domProps: { value: key, checked: _vm.isChecked[key] },
              }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.options[key]) +
                  "\n            "
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }